const landingConfig = {
  siteName: 'Puerto Rico Windows & Doors',
  siteTitle: 'Puerto Rico Windows & Doors | Ventanas y Puertas de Impacto',
  metaDescription:
    'Puerto Rico Windows & Doors - instalación rápida, calidad garantizada y servicio inteligente de cotización para ventanas, puertas y puertas de garage.',
  metaKeywords:
    'ventanas impacto Puerto Rico, puertas calidad garantizada, instalación rápida, puertas de garage premium, cotización inmediata ventanas',
  logo: '/logo-bbts.png',
  whatsappPhone: '17872369189',
  whatsappMessage: 'Hola Puerto Rico Windows & Doors, necesito una cotización para ventanas y puertas.',
  googleTagId: 'AW-16987830296',
  redirectUTM: 'google',
  redirectWhatsAppLink: 'https://wa.me/17872369189?text=Hola%20Puerto%20Rico%20Windows%20%26%20Doors%2C%20necesito%20una%20cotizaci%C3%B3n',

  hero: {
    pretitle: 'Servicio veloz • calidad garantizada',
    image: 'https://images.unsplash.com/photo-1484154218962-a197022b5858?auto=format&fit=crop&w=1600&q=80',
    title: 'Ventanas y puertas de impacto listas para instalar',
    subtitle:
      'Fabricamos e instalamos ventanas, puertas y puertas de garaje certificados para Puerto Rico. Servicio rápido, asesoría experta y cotizaciones inteligentes en minutos.',
    bullets: [
      'Series de impacto con vidrio laminado y Low-E',
      'Puertas pivot, multi slide y corredizas premium',
      'Cotizador inteligente con captura de medidas',
      'Instalación certificada y garantía extendida',
      'Soporte inmediato para arquitectos y contratistas',
      'Programas comerciales para proyectos grandes',
    ],
    cta: 'Cotizar mi proyecto',
  },

  navigation: [
    { label: 'Productos', href: '#products', sublabel: 'Ventanas · Puertas inteligentes' },
    { label: 'Projects', href: '#projects', sublabel: 'Gallery · Overview' },
    { label: 'Professionals', href: '#professionals', sublabel: 'Arquitectos · Instaladores · Comercios' },
    { label: 'Resources', href: '#resources', sublabel: 'Blog · FAQs · Garantías' },
    { label: 'About Us', href: '#about', sublabel: 'Equipo · Certificaciones' },
  ],

  featuredProducts: [
    {
      title: 'Windows',
      subtitle: 'Casement Series',
      description: 'Sellado hermético, bisagras reforzadas y eficiencia energética para el trópico.',
      image: 'https://images.unsplash.com/photo-1493663284031-b7e3aefcae8e?auto=format&fit=crop&w=1000&q=80',
    },
    {
      title: 'Doors',
      subtitle: 'Pivot Series',
      description: 'Puertas icónicas con panel XL, eje pivot y certificaciones de impacto.',
      image: 'https://images.unsplash.com/photo-1505692794400-2b01db48e9cc?auto=format&fit=crop&w=1000&q=80',
    },
  ],

  impactHighlights: [
    'Vidrio laminado + marco reforzado para zonas huracanadas.',
    'Pruebas de impacto, presión positiva/negativa y acústica.',
    'Certificaciones Miami-Dade, Florida NOA y ASTM.',
  ],

  professionalSegments: [
    {
      title: 'Home Improvement',
      desc: 'Programas para remodeladores y contratistas certificados.',
    },
    {
      title: 'Architecture & Design',
      desc: 'Soporte técnico, BIM y muestras para estudios de diseño.',
    },
    {
      title: 'Commercial Projects',
      desc: 'Soluciones de gran escala para hoteles, hospitales y oficinas.',
    },
  ],

  showProfessionalSection: true,
  showTestimonialSection: true,

  whyChoose: [
    { title: 'Industry Leadership', desc: '50+ años fabricando sistemas para el Caribe.' },
    { title: 'Impact Resistance', desc: 'Ensayos de huracán categoría 5 y forced-entry.' },
    { title: 'Energy Efficiency', desc: 'Perfiles térmicos y vidrio Low-E para reducir consumo.' },
    { title: 'Turnkey Support', desc: 'Ingeniería, instalación y servicio postventa.' },
  ],

  blogPosts: [
    {
      title: 'Cómo seleccionar ventanas para zonas costeras',
      date: 'Feb 2025',
      link: '#',
    },
    {
      title: 'Guía de certificaciones Miami-Dade y Florida NOA',
      date: 'Jan 2025',
      link: '#',
    },
    {
      title: 'Tendencias en puertas pivot para residencias premium',
      date: 'Dec 2024',
      link: '#',
    },
  ],

  showWhySection: true,
  showBlogSection: true,
  showContactSection: true,

  aboutSection: {
    eyebrow: 'About Us',
    title: 'Nuestra historia y equipo',
    subtitle: 'Conoce a las personas detrás de cada instalación.',
    story:
      'Somos un equipo especializado en ventanas y puertas de impacto para el Caribe. Combinamos experiencia técnica, soporte cercano y procesos ágiles para entregar proyectos seguros y estéticos.',
    images: [
      'https://images.unsplash.com/photo-1521737604893-d14cc237f11d?auto=format&fit=crop&w=1200&q=80',
      'https://images.unsplash.com/photo-1522071820081-009f0129c71c?auto=format&fit=crop&w=1200&q=80',
      'https://images.unsplash.com/photo-1521737711867-e3b97375f902?auto=format&fit=crop&w=1200&q=80',
    ],
  },

  contactInfo: {
    title: '¿Listo para hablar con un especialista?',
    description:
      'Cuéntanos sobre tu proyecto de ventanas o puertas. Respondemos en menos de 24 horas con recomendaciones, comparativas y precios preliminares.',
    email: 'info@puertoricowindows.com',
    whatsapp: '+1 (787) 236-9189',
    hours: 'Lunes a Viernes · 8:00am – 6:00pm',
    location: 'Puerto Rico y Florida',
    ctaCard: {
      text: '¿Prefieres completar la solicitud en otra pestaña? Puedes abrir el formulario inteligente desde aquí.',
      button: 'Abrir formulario de cotización',
    },
  },

  wizardOptions: {
    colors: [
      { id: 'blanco', label: 'Blanco' },
      { id: 'negro', label: 'Negro' },
      { id: 'bronce', label: 'Bronce' },
      { id: 'custom', label: 'Personalizado' },
    ],
    glass: [
      { id: 'clear', label: 'Clear' },
      { id: 'lowe', label: 'Low-E' },
      { id: 'laminado', label: 'Laminado acústico' },
      { id: 'reflectivo', label: 'Reflectivo' },
    ],
    finish: [
      { id: 'mate', label: 'Mate' },
      { id: 'satinado', label: 'Satinado' },
      { id: 'texturizado', label: 'Texturizado' },
      { id: 'anodizado', label: 'Anodizado' },
    ],
    series: [
      { id: 'lama3', label: 'Lama 3' },
      { id: 'lama4', label: 'Lama 4' },
      { id: 'lama6', label: 'Lama 6' },
    ],
  },

  footer: {
    description:
      'Especialistas en puertas y ventanas de alto desempeño para residencias, comercios y desarrollos en el Caribe.',
  },

  copy: {
    header: {
      tagline: 'Sistemas inteligentes para puertas y ventanas.',
      marketsLabel: 'Mercados',
      menuLabel: 'Abrir menú',
      markets: ['Puerto Rico', 'Florida'],
      loginLabel: 'Acceder a mi cuenta',
      ecommerceLabel: 'Tienda en línea',
      quoteLabel: 'Cotizar ahora',
    },
    hero: {
      loginLabel: 'Acceder a mi cuenta',
      ecommerceLabel: 'Tienda en línea',
      quickFormLabel: 'Formulario rápido',
      quickFormTitle: 'Solicita tu propuesta',
      quickFormClose: 'Cerrar',
    },
    servicesSection: {
      eyebrow: 'Servicios destacados',
      subtitle: 'Soluciones completas con materiales certificados y acabados premium.',
      galleryLabel: 'Ver galería →',
    },
    productSection: {
      eyebrow: 'Variedad completa',
      title: 'Ventanas, puertas y puertas de garage.',
      subtitle: 'Explora los estilos más solicitados y cotiza en segundos.',
      galleryLabel: 'Galería interactiva',
      quoteLabel: 'Cotizar',
    },
    measurementSection: {
      eyebrow: 'Configura tus medidas',
      title: 'Ingresa dimensiones y acabados.',
      subtitle:
        'Capturamos ancho, alto (en pulgadas), tipo de cristal y color. Tu información genera un lead estructurado y un PDF preliminar para tu asesor.',
      mobileToggleLabel: 'Pasos para medir',
      mobileToggleOpen: 'Ver',
      mobileToggleClose: 'Cerrar',
      infoTitle: '¿Qué sucede con tu información?',
      infoDescription:
        'Guardamos contacto, medidas y accesorios seleccionados. Solo el equipo de Puerto Rico Windows & Doors recibe estos datos para validar tu proyecto.',
      wizardCta: 'Iniciar asistente paso a paso',
      infoFootnote: 'O completa el formulario integrado en esta misma sección.',
    },
    quoteStepsSection: {
      eyebrow: 'Servicio rápido y garantizado',
      title: 'Así aseguramos calidad y tiempos de entrega.',
      subtitle: 'Proceso inteligente, instalación profesional y soporte postventa para que tu inversión esté protegida.',
      taglines: ['Diagnóstico rápido', 'Optimización automática', 'Entrega garantizada'],
      ctaLabel: 'Solicitar servicio →',
    },
    featuredProductsSection: {
      eyebrow: 'Productos destacados',
      title: 'Ventanas y puertas inteligentes',
      subtitle: 'Series con impacto, eficiencia y acabado premium.',
      ctaLabel: 'Learn More →',
    },
    impactSection: {
      eyebrow: 'Impact Resistance',
      title: 'Pruebas que exceden los códigos.',
      subtitle:
        'Cada ventana y puerta se somete a ensayos de laboratorio y campo para garantizar desempeño contra huracanes, intrusiones y humedad salina.',
      buttonLabel: 'Impact Solutions',
      cardText: 'Ensayos de presión estática, proyectiles y ciclos para validar desempeño real.',
      cardImage: 'https://images.unsplash.com/photo-1505691938895-1758d7feb511?auto=format&fit=crop&w=1200&q=80',
      cardAlt: 'Impact Resistance',
    },
    professionalSection: {
      eyebrow: 'Professional Solutions',
      title: 'Diseñado para cada tipo de profesional.',
      ctaLabelPrefix: 'Explore',
      ctaLabelSuffix: '→',
    },
    testimonialSection: {
      eyebrow: 'Seeing is believing',
      quote:
        '“Como Santo Tomás, tenía que verlo para creerlo. Las puertas de Puerto Rico Windows & Doors soportaron el último huracán sin una sola filtración.”',
      author: 'Cliente residencial · Zona costera',
    },
    whySection: {
      eyebrow: 'Por qué elegirnos',
      title: 'Beneficios que nos diferencian.',
    },
    blogSection: {
      eyebrow: 'Resources',
      title: 'Últimos artículos del blog.',
      ctaLabel: 'Read Article →',
    },
    footerSection: {
      navTitle: 'Navegación',
      contactTitle: 'Contacto',
      rightsText: 'Todos los derechos reservados.',
    },
    contactSection: {
      eyebrow: 'Contacto directo',
      labels: {
        email: 'Email',
        whatsapp: 'WhatsApp',
        hours: 'Horario',
        location: 'Regiones',
      },
      ctaFootnote: 'También puedes llenar el formulario directamente en la sección “Configura tus medidas”.',
    },
    wizard: {
      title: 'Asistente de cotización',
      subtitle: 'Configura tu estilo ideal',
      description: 'Completa cada paso y agregaremos el modelo a tu cotización.',
      steps: ['Producto', 'Medidas', 'Acabados', 'Resumen'],
      step2Hint: 'Ingresa alto, ancho y cantidad para continuar.',
      selectedLabel: 'Seleccionado',
      step3ColorLabel: 'Color del marco',
      step3GlassLabel: 'Cristal',
      step3FinishLabel: 'Acabado',
      summaryMeasurementsLabel: 'Medidas',
      summarySeriesLabel: 'Serie',
      summaryFinishLabel: 'Color / Cristal / Acabado',
      summaryUnitLabel: 'unidad(es)',
      summaryEmptyValue: '-',
      summaryTitleFallback: 'Modelo seleccionado',
      noStylesText: 'No hay estilos configurados para esta categoría.',
      summaryHelper: 'Estos valores alimentarán el formulario de cotización para agilizar tu solicitud.',
      heightLabel: 'Alto (pulgadas)',
      widthLabel: 'Ancho (pulgadas)',
      quantityLabel: 'Cantidad',
      seriesLabel: 'Serie (lama)',
      prevLabel: 'Atrás',
      nextLabel: 'Siguiente',
      finishLabel: 'Agregar a mi cotización',
      closeLabel: 'Cerrar',
    },
    modals: {
      galleryLabel: 'Galería',
      galleryClose: 'Cerrar',
      galleryCta: 'Cotizar este estilo',
      galleryPrevLabel: 'Imagen anterior',
      galleryNextLabel: 'Imagen siguiente',
      quoteModalLabel: 'Añadir a tu cotización',
      quoteModalSave: 'Guardar modelo en la cotización',
      quoteModalCancel: 'Cancelar',
      quoteModalCloseLabel: 'Cerrar',
      quoteModalError: 'Ingresa alto, ancho y cantidad válidos para continuar.',
    },
    assistant: {
      buttonLabel: 'Asistente AI',
      label: 'AI Assistant',
      title: 'Puerto Rico Windows & Doors',
      greeting:
        'Hola, soy el asistente virtual de Puerto Rico Windows & Doors. ¿Te ayudo con una nueva cotización o con soporte de un proyecto existente?',
      compactLabel: 'Modo compacto',
      wideLabel: 'Modo amplio',
      inputPlaceholder: 'Escribe tu pregunta o descríbenos tu proyecto...',
      sendLabel: 'Enviar',
      loadingLabel: 'Pensando...',
      fallbackReply: 'Gracias por escribirnos. Un asesor tomará tu caso de inmediato.',
      errorReply:
        'Hubo un inconveniente al procesar la consulta. Escríbenos a info@puertoricowindows.com o WhatsApp +1 (787) 236-9189.',
      errorNotice: 'No pudimos conectar con el asistente. Intenta nuevamente en unos segundos.',
    },
    floatingQuoteButton: 'Ver mi cotización',
  },

  servicesTitle: 'Variedad completa',
  services: [
    {
      src: 'https://images.unsplash.com/photo-1493663284031-b7e3aefcae8e?auto=format&fit=crop&w=900&q=80',
      title: 'Ventanas de impacto',
      desc: 'Casement, fixed, sliding y awning con perfiles premium.',
      gallery: [
        'https://images.unsplash.com/photo-1493663284031-b7e3aefcae8e?auto=format&fit=crop&w=900&q=80',
        'https://images.unsplash.com/photo-1505691723518-36a5ac3be353?auto=format&fit=crop&w=900&q=80',
        'https://images.unsplash.com/photo-1484154218962-a197022b5858?auto=format&fit=crop&w=900&q=80',
      ],
    },
    {
      src: 'https://images.unsplash.com/photo-1505692794400-2b01db48e9cc?auto=format&fit=crop&w=900&q=80',
      title: 'Puertas arquitectónicas',
      desc: 'Pivot, multi slide, french y sliding glass con herrajes ocultos.',
      gallery: [
        'https://images.unsplash.com/photo-1505692794400-2b01db48e9cc?auto=format&fit=crop&w=900&q=80',
        'https://images.unsplash.com/photo-1505693314120-0d443867891c?auto=format&fit=crop&w=900&q=80',
        'https://images.unsplash.com/photo-1501183638710-841dd1904471?auto=format&fit=crop&w=900&q=80',
      ],
    },
    {
      src: 'https://images.unsplash.com/photo-1616593631056-0f0e687a19bd?auto=format&fit=crop&w=900&q=80',
      title: 'Puertas de garaje',
      desc: 'Sistemas seccionales y full view con motor inteligente y opcionales hurricane rated.',
      gallery: [
        'https://images.unsplash.com/photo-1616593631056-0f0e687a19bd?auto=format&fit=crop&w=900&q=80',
        'https://images.unsplash.com/photo-1481277542470-605612bd2d61?auto=format&fit=crop&w=900&q=80',
        'https://images.unsplash.com/photo-1460574283810-2aab119d8511?auto=format&fit=crop&w=900&q=80',
      ],
    },
  ],

  form: {
    showText: 'Abrir cotizador inteligente',
    hideText: 'Cerrar cotizador',
  },

  login: {
    text: '¿Ya eres cliente?',
    button: 'Inicia sesión',
  },

  calendar: {
    title: 'Agenda una reunión virtual',
    floatTitle: 'Agendar',
  },

  whatsappFloat: {
    link: 'https://wa.me/17872369189?text=Hola%20Puerto%20Rico%20Windows%20%26%20Doors%2C%20necesito%20una%20cotizaci%C3%B3n',
  },
  whatsappModal: {
    buttonText: 'Hablar por WhatsApp',
  },
  theme: {
    primary: '#0f5132',
    primaryDark: '#0b3d24',
    accent: '#1c1f23',
    gradientFrom: '#f4f7f4',
    gradientTo: '#ffffff',
    highlight: '#dfeee4',
    cardBg: '#ffffff',
    cardBorder: '#d3e1d1',
    background: '#f9fafb',
    surface: '#ffffff',
    surfaceAlt: '#f6faf6',
    text: '#1f2937',
    muted: '#6b7280',
    heroOverlayFrom: '#02180e',
    heroOverlayTo: '#03351d',
    heroText: '#ffffff',
    heroMuted: '#d1fae5',
    heroCtaPrimaryBg: '',
    heroCtaPrimaryText: '#ffffff',
    heroCtaSecondaryBg: '#ffffff1a',
    heroCtaSecondaryText: '#ffffff',
    heroCtaSecondaryBorder: '#ffffff66',
    fontFamily: 'ui-sans-serif, system-ui, -apple-system, Segoe UI, sans-serif',
    fontUrl: '',
  },

  animations: {
    hero: 'fade-in',
    section: 'fade-in-up',
    card: 'slide-up',
  },

  productCategories: [
    {
      title: 'Ventanas',
      desc: 'Series de impacto con perfiles premium y opciones de cristal Low-E.',
      styles: [
        {
          name: 'Casement',
          desc: 'Apertura lateral con sellos herméticos.',
          images: [
            'https://images.unsplash.com/photo-1493663284031-b7e3aefcae8e?auto=format&fit=crop&w=900&q=80',
            'https://images.unsplash.com/photo-1505691723518-36a5ac3be353?auto=format&fit=crop&w=900&q=80',
            'https://images.unsplash.com/photo-1484154218962-a197022b5858?auto=format&fit=crop&w=900&q=80',
          ],
        },
        {
          name: 'Fixed',
          desc: 'Panel panorámico para vistas sin interrupciones.',
          images: [
            'https://images.unsplash.com/photo-1481277542470-605612bd2d61?auto=format&fit=crop&w=900&q=80',
            'https://images.unsplash.com/photo-1449844908441-8829872d2607?auto=format&fit=crop&w=900&q=80',
          ],
        },
        {
          name: 'Sliding',
          desc: 'Corredizas suaves que optimizan espacios reducidos.',
          images: [
            'https://images.unsplash.com/photo-1505691938895-1758d7feb511?auto=format&fit=crop&w=900&q=80',
            'https://images.unsplash.com/photo-1505693314120-0d443867891c?auto=format&fit=crop&w=900&q=80',
          ],
        },
        {
          name: 'Awning',
          desc: 'Bisagra superior que permite ventilar aun con lluvia.',
          images: [
            'https://images.unsplash.com/photo-1505692794400-2b01db48e9cc?auto=format&fit=crop&w=900&q=80',
            'https://images.unsplash.com/photo-1460574283810-2aab119d8511?auto=format&fit=crop&w=900&q=80',
          ],
        },
      ],
    },
    {
      title: 'Puertas',
      desc: 'Puertas arquitectónicas con herrajes ocultos y cierres multipunto.',
      styles: [
        {
          name: 'Pivot',
          desc: 'Panel XL con eje desplazado y acabados premium.',
          images: [
            'https://images.unsplash.com/photo-1505692794400-2b01db48e9cc?auto=format&fit=crop&w=900&q=80',
            'https://images.unsplash.com/photo-1505693314120-0d443867891c?auto=format&fit=crop&w=900&q=80',
          ],
        },
        {
          name: 'French',
          desc: 'Doble hoja con máxima iluminación.',
          images: [
            'https://images.unsplash.com/photo-1505691938895-1758d7feb511?auto=format&fit=crop&w=900&q=80',
            'https://images.unsplash.com/photo-1501183638710-841dd1904471?auto=format&fit=crop&w=900&q=80',
          ],
        },
        {
          name: 'Sliding Glass',
          desc: 'Corredizas reforzadas para aperturas amplias.',
          images: [
            'https://images.unsplash.com/photo-1460574283810-2aab119d8511?auto=format&fit=crop&w=900&q=80',
            'https://images.unsplash.com/photo-1505691723518-36a5ac3be353?auto=format&fit=crop&w=900&q=80',
          ],
        },
        {
          name: 'Multi Slide',
          desc: 'Paneles apilables que integran interior y exterior.',
          images: [
            'https://images.unsplash.com/photo-1505693314120-0d443867891c?auto=format&fit=crop&w=900&q=80',
            'https://images.unsplash.com/photo-1493663284031-b7e3aefcae8e?auto=format&fit=crop&w=900&q=80',
          ],
        },
      ],
    },
    {
      title: 'Puertas de garage',
      desc: 'Sistemas seccionales, full view y hurricane rated con automatización.',
      styles: [
        {
          name: 'Seccionales',
          desc: 'Paneles termoaislados con motor inteligente.',
          images: [
            'https://images.unsplash.com/photo-1616593631056-0f0e687a19bd?auto=format&fit=crop&w=900&q=80',
            'https://images.unsplash.com/photo-1505691723518-36a5ac3be353?auto=format&fit=crop&w=900&q=80',
          ],
        },
        {
          name: 'Full View',
          desc: 'Aluminio y cristal para proyectos comerciales.',
          images: [
            'https://images.unsplash.com/photo-1484154218962-a197022b5858?auto=format&fit=crop&w=900&q=80',
            'https://images.unsplash.com/photo-1505693314120-0d443867891c?auto=format&fit=crop&w=900&q=80',
          ],
        },
        {
          name: 'Hurricane Rated',
          desc: 'Resistencia certificada para zonas costeras.',
          images: [
            'https://images.unsplash.com/photo-1505692794400-2b01db48e9cc?auto=format&fit=crop&w=900&q=80',
            'https://images.unsplash.com/photo-1505691938895-1758d7feb511?auto=format&fit=crop&w=900&q=80',
          ],
        },
      ],
    },
  ],

  measurementGuidelines: [
    { title: '1. Usa cinta metálica', desc: 'Mide dentro del marco interior y mantén la cinta tensa.' },
    { title: '2. Alto × Ancho', desc: 'Siempre ingresa primero el alto y luego el ancho (ej. 72" x 48").' },
    { title: '3. Cantidades', desc: 'Indica cuántas unidades por diseño para tu proyecto.' },
  ],

  quoteSteps: [
    { title: 'Describe tu proyecto', desc: 'Selecciona tipo de apertura, ubicación y certificaciones.' },
    { title: 'Motor inteligente', desc: 'El algoritmo cruza medidas con la tabla Lama 3 / Lama 4.' },
    { title: 'Cotización inmediata', desc: 'Generamos un PDF preliminar y un lead para tu asesor.' },
  ],
};

export default landingConfig;
